@if (showButton) {
  <button
    mat-fab
    extended
    class="feedback-fab d-flex align-items-center"
    [class.feedback-fab--footer-below-fold]="!footerInView"
    (click)="openModal($event)"
    [matTooltip]="'modals.feedback-report.button-tooltip' | translate"
  >
    <mat-icon class="feedback-fab-icon">help_outline</mat-icon>
    <span class="feedback-fab-label">{{
      'modals.feedback-report.button-label' | translate
    }}</span>
  </button>
}
